import React, { Component } from 'react';
import Aviation  from "../../assets/rides/service-aviation.jpg";
import Boat from "../../assets/rides/service-boat.jpg";
import Nautical from "../../assets/rides/service-nautical.jpg";
import RV from "../../assets/rides/service-rv.jpg";
import ATV from "../../assets/rides/service-atv.jpg";
import Bike from "../../assets/rides/service-bike.jpg";

export default class Rides extends Component {

    render() {
        return (
            <div className="rides__main">
                <div className="rides__container">
                    <div className="rides__item">
                        <h4 className="rides__title"> Bateaux </h4>
                        <img src={Boat} className="rides__img" />
                    </div>
                    <div className="rides__item">
                        <h4 className="rides__title"> VR </h4>
                        <img src={RV} className="rides__img" />
                    </div>
                    <div className="rides__item">
                        <h4 className="rides__title"> Tout Terrain </h4>
                        <img src={ATV} className="rides__img" />
                    </div>
                    <div className="rides__item">
                        <h4 className="rides__title"> Aviation </h4>
                        <img src={Aviation} className="rides__img" />
                    </div>
                    <div className="rides__item">
                        <h4 className="rides__title"> Nautique </h4>
                        <img src={Nautical} className="rides__img" />
                    </div>
                    <div className="rides__item">
                        <h4 className="rides__title"> Loisir </h4>
                        <img src={Bike} className="rides__img" />
                    </div>
                </div>
            </div>
        )
    }
}